/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description Location Icon -- used in web-zumper search autocomplete
 */

import * as React from 'react'

import location from '../../../img/location.svg'
import locationAutocomplete from '../../../img/locationAutocomplete.svg'
import { ImgIconProps } from '../../../types'

interface Props extends ImgIconProps {
  variant: 'Default' | 'Autocomplete'
}

export const Location = ({ size = 24, alt = 'Location', variant = 'Default', ...props }: Props) => {
  let iconSrc = ''
  if (variant === 'Default') {
    iconSrc = location
  } else if (variant === 'Autocomplete') {
    iconSrc = locationAutocomplete
  }

  return <img alt={alt} height={size} loading="lazy" src={iconSrc} width={size} {...props} />
}
